import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { NgxSpinnerService } from "ngx-spinner";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

    constructor(private spinner: NgxSpinnerService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.spinner.show();
        return next.handle(req).do(evt => {
            if (evt instanceof HttpResponse) {
                this.spinner.hide();
            }
        }, err => {
            this.spinner.hide();
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/core/interceptors/http-request-interceptor.ts